import { AxiosError, AxiosResponse } from 'axios';

export const handleApiResponse = <T>(response: AxiosResponse): T => {
  try {
    if (!response.data) {
      throw new Error('No response data');
    }
    const { data, status, statusCode, message, error } = response.data;
    const statusCheck = status || statusCode;
    if (
      statusCheck &&
      statusCheck !== 200 &&
      statusCheck !== 201 &&
      statusCheck !== 204
    ) {
      if (typeof window !== 'undefined') throw new Error(message || error);
      return null as any;
    }
    return data;
  } catch (error: any) {
    if (typeof window !== 'undefined') throw new Error(error.message);
    return null as any;
  }
};

export const handleErrorResponse = (
  error: any,
  defaultMessage = 'basic.apiError',
) => {
  if (typeof error === 'string') return error || defaultMessage;

  if (error instanceof AxiosError) {
    let message = 'Something went wrong';
    if (error.response?.data?.message) {
      message = error.response.data?.message;
    } else if (error.response?.data?.error) {
      message = error.response.data.error;
    } else if (error.response?.data?.errors) {
      message = error.response.data.errors[0]?.message;
    }
    return message;
  }

  if (error instanceof Error) {
    return error.message;
  }
  return error.message || defaultMessage || 'Unknown error';
};
